<template>
  <div id="box">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="$t('mobileAuthorization.title')" />
        <div class="sectionWrapper">
          <p
            v-html="$t('mobileAuthorization.aboutAppSubtitle')"
            class="subtitle"
          />
          <p v-html="aboutAppDescription" class="description" />
        </div>
        <div class="sectionWrapper">
          <p
            v-html="$t('mobileAuthorization.accountPreparationSubtitle')"
            class="subtitle"
          />
          <div class="itemList">
            <p
              v-html="$t('mobileAuthorization.accountPreparationItem1')"
              class="subtitle"
            />
          </div>
          <div class="itemList">
            <p
              v-html="$t('mobileAuthorization.accountPreparationItem2')"
              class="subtitle"
            />
            <p
              v-html="
                $t('mobileAuthorization.accountPreparationItem2Description')
              "
              class="description"
            />
            <img
              v-svg-inline
              class="img mncPassword"
              src="../assets/imgs/mnc_password_signature.svg"
              alt="mncPassword"
            />
          </div>
        </div>
        <div class="sectionWrapper last">
          <p
            v-html="$t('mobileAuthorization.installStepsSubtitle')"
            class="subtitle"
          />
          <div class="stepList">
            <div class="stepIconWrapper">
              <div class="stepIcon"><div>1</div></div>
            </div>
            <div class="stepContentWrapper">
              <p
                v-html="
                  $t('mobileAuthorization.stepSubtitle', {
                    step: 1,
                    subtitle: textBold(
                      $t('mobileAuthorization.installStep1Subtitle')
                    ),
                  })
                "
                class="subtitle"
              />
              <p
                v-html="$t('mobileAuthorization.installStep1Description')"
                class="description"
              />
              <a
                href="https://apps.apple.com/jp/app/%E3%82%AF%E3%83%AD%E3%82%B9%E3%82%A2%E3%82%A4%E3%83%87%E3%82%A3/id1495147544"
                v-if="isDeviceIOS"
                ><img
                  v-svg-inline
                  class="img appDownload"
                  src="../assets/imgs/app_store_badge.svg"
                  alt="appDownload"
              /></a>
              <a
                href="https://play.google.com/store/apps/details?id=me.x.id"
                v-if="!isDeviceIOS"
                ><img
                  v-svg-inline
                  class="img appDownload"
                  src="../assets/imgs/google_play_store_badge.svg"
                  alt="appDownload"
              /></a>
            </div>
          </div>
          <div class="stepList">
            <div class="stepIconWrapper">
              <div class="stepIcon"><div>2</div></div>
            </div>
            <div class="stepContentWrapper">
              <p
                v-html="
                  $t('mobileAuthorization.stepSubtitle', {
                    step: 2,
                    subtitle: textBold(
                      $t('mobileAuthorization.installStep2Subtitle')
                    ),
                  })
                "
                class="subtitle"
              />
              <p v-html="installStep2Description" class="description" />
            </div>
          </div>
          <div class="stepList last">
            <div class="stepIconWrapper">
              <div class="stepIcon"><div>3</div></div>
            </div>
            <div class="stepContentWrapper">
              <p
                v-html="
                  $t('mobileAuthorization.stepSubtitle', {
                    step: 3,
                    subtitle: textBold(
                      $t('mobileAuthorization.installStep3Subtitle')
                    ),
                  })
                "
                class="subtitle"
              />
              <p v-html="installStep3Description" class="description" />
            </div>
          </div>
        </div>
      </div>
      <div class="verticalWrapper">
        <CustomButton
          :buttonType="'primary'"
          :customButtonTxt="$t('customButton.downloadApp')"
          @submit="downloadApp"
        />
        <div class="space" />
        <CustomButton
          :disabled="invalid"
          :isDisabled="invalid"
          :isLoading="customButtonLoading"
          :buttonType="'border'"
          :customButtonTxt="$t('mobileAuthorization.launchApp')"
          @submit="mobileAuthorization"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
import { isIOS } from "mobile-device-detect";

export default {
  name: "MobileAuthorization",
  components: {
    CustomButton,
  },
  props: {
    invalidEmail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customButtonLoading: false,
      emailValue: "",
      isDeviceIOS: isIOS,
    };
  },
  watch: {
    invalidEmail: {
      deep: true,
      handler: function (newVal) {
        this.customButtonLoading = false;
        if (newVal != true) {
          return;
        }
        this.$refs.myForm.setErrors({
          email: [this.$t("serverError.unregistered")],
        });
      },
    },
  },
  computed: {
    aboutAppDescription() {
      const hereLink = this.getURL(
        "https://xid.inc/application",
        this.$t("mobileAuthorization.here")
      );
      return this.$t("mobileAuthorization.aboutAppDescription", {
        hereLink: hereLink,
      });
    },
    installStep2Description() {
      const hereLink = this.getURL(
        "https://help.xid.inc/ab18212dc0f947fc88653ea90e96905d",
        this.$t("mobileAuthorization.here")
      );
      const mynumberCard = this.textBold(
        this.$t("mobileAuthorization.mynumberCard")
      );
      const mncPassword = this.textBold(
        this.$t("mobileAuthorization.mncPassword")
      );
      return this.$t("mobileAuthorization.installStep2Description", {
        mynumberCard: mynumberCard,
        mncPassword: mncPassword,
        hereLink: hereLink,
      });
    },
    installStep3Description() {
      const launchApp = this.textBold(this.$t("mobileAuthorization.launchApp"));
      return this.$t("mobileAuthorization.installStep3Description", {
        launchApp: launchApp,
      });
    },
  },
  methods: {
    getURL(url, txt) {
      return `<a class="hereLink" style="color: #33CEAA" href="${url}" target="_blank" aria-label="${txt}" rel="noopener">${txt}</a>`;
    },
    textBold(txt) {
      return `<span class="bold" style="color: #222222">${txt}</span>`;
    },
    downloadApp() {
      if (isIOS) {
        window.open(
          "https://apps.apple.com/jp/app/%E3%82%AF%E3%83%AD%E3%82%B9%E3%82%A2%E3%82%A4%E3%83%87%E3%82%A3/id1495147544"
        );
      } else {
        window.open("https://play.google.com/store/apps/details?id=me.x.id");
      }
    },
    mobileAuthorization() {
      this.$emit("mobileAuthorization");
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .verticalWrapper
    +size(100%, auto)
    .space
      +size(100%, 8px)
  .scrollWrapper
    margin-bottom: 16px
    .sectionWrapper
      margin-bottom: 20px
      &.last
        margin-bottom: 0px !important
      p.subtitle
        +fs(l)
      .itemList
        p.subtitle
          +fs(m)
          &:before
            content: '・'
        p.description
          &:before
            content: '\00a0'
        .img
          +size(80%)
          margin-top: 8px
          margin-left: 10%
          margin-right: 10%
      .stepList
        +flex(flex-start, flex-start, row)
        margin-bottom: 16px
        &.last
          margin-bottom: 0px !important
        .stepIconWrapper
          width: 32px
          margin-right: 8px
          .stepIcon
            +size(32px,32px,100%)
            background-color: $color1
            +flex(center, center)
            div
              +ffw(black)
              +fs(l)
              color: $gs1
        .stepContentWrapper
          p.subtitle
            height: 32px
            line-height: 32px
            +fs(m)
            +ffw(black)
            color: $color1
            span.bold
              +ffw(black)
              padding-left: 4px
</style>
